import React from 'react';

import { colors } from '@/assets/styles/colors';
import { useTranslation } from '@/i18n';
import { Card } from '@/components/ui/cards';
import { Text } from '@/components/ui/text/Text';
import { Table } from '@/components/ui/tables/Table';
import { FilterDropdown } from '@/components/ui/filters/FilterDropdown';
import { useProcessHistoryList } from '@/hooks/attendance/recalculation/useProcessHistoryList';


export const ProcessHistorySection: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    columns,
    actions,
    filterConfig,
    onSearch,
    onSortChange,
    loading,
    filters,
    handleFilterChange,
  } = useProcessHistoryList();

  return (
    <Card data-testid="process-history-section">
      <div className="flex flex-col gap-4 p-2">
        <Text variant="body-title-medium" color={colors.primary.main}>
          {translate('attendance:recalculo.historicoProcesos.title')}
        </Text>
        <div className="flex flex-wrap gap-3 items-center">
          <FilterDropdown
            filters={filterConfig}
            values={{ status: filters.status ?? '' }}
            onChangeFilter={handleFilterChange}
            closeOnSelect
          />
        </div>
        <Table
          columns={columns}
          data={rows}
          totalRows={total}
          searchable
          searchPlaceholder={translate('common:actions.search')}
          onSearch={onSearch}
          onSortChange={onSortChange}
          serverSideSort
          initialSort={{ key: 'executionDate', direction: 'desc' }}
          pagination={{
            page,
            pageSize,
            total,
            onChange: setPage,
            onPageSizeChange: setPageSize,
          }}
          isLoading={loading}
          actions={actions}
          data-testid="process-history-table"
        />
      </div>
    </Card>
  );
};

export default ProcessHistorySection;
